$(document).ready(function () {

	
	// formulaire de login
	$('#wamiloginform').submit(function(e){
		e.preventDefault();
		$('.login_error').remove();
		var form        = $(this);
		var postData    = form.serialize();
		var action 		= form.attr('action'); //console.log(action);
		$.ajax({
			url     : wami_js.ajaxurl,
			data:{                    
				action 	: action,
				data    : postData,
            },
			success : function(response){
				//console.log(response);
				if( $.trim(response)=='ok' ){
					window.location.href = $("input[name=redirect_to]").val();
				}else{
					var obj = jQuery.parseJSON(response);
					if(form.find('.login_error').length) form.find('.login_error').html(obj.message);
					else form.append('<p class="login_error">'+obj.message+'</p>');
					return false;
				}
			},
			error : function(response){
				console.log('erreur');
			}
		});
	});

	// formulaire du lost password
	$('#wamilostpasswordform').submit(function(e){
		e.preventDefault();
		$('.popup.connexion .message').empty();
		var form        = $(this);
		var postData    = form.serialize();
		var action 		= form.attr('action');
		$.ajax({
			url:wami_js.ajaxurl,
			data:{                    
				action 	: action,
				data    : postData,
            },
			success:function(response){
				if( $.trim(response)=='ok' ){
					$(form).html('<p>Un e-mail contenant votre nouveau mot de passe vient de vous être envoyé.</p>');
					$(form).find('.fields, button').hide();
				}else{
					//console.log(response);
					$('.popup.connexion .message').html(response);
					return false;
				}
			}
		});
	});

	// formulaire de creation de user
	$('#registerform').submit(function(e){
		e.preventDefault();
		$('.form_inscription .message_register').empty();
		var form        = $(this);
		var postData    = form.serialize();
		var action 		= form.attr('action');
		$.ajax({
			url:wami_js.ajaxurl,
			data:{                    
				action 	: action,
				data    : postData,
            },
			success:function(response){
				var obj = jQuery.parseJSON(response);				
				if(obj.erreur==false){
					//console.log('pas d\'erreur');
					//$(form).html('<p>Merci de votre inscription.</p><div class="button_validation button button--primary"><a href="'+wami_js.siteurl+'" class="btn_validation button--primary-for_input">Je me connecte</a></div>');
					window.location.href = wami_js.siteurl;
				}else{
					//console.log(obj);
					$('.form_inscription .message_register').html(obj.liste_erreur);
				}				
			}
		});
	});

	
});